/* ------------------------------------------------------------------ */
/* Singleton Firebase client – browser only                            */
/* ------------------------------------------------------------------ */
import { initializeApp, getApps } from "firebase/app";
import { getAuth, browserSessionPersistence, setPersistence } from "firebase/auth";
import { getMessaging, isSupported, Messaging } from "firebase/messaging";

/* ---------- config ---------- */
const firebaseConfig = {
  apiKey: "AIzaSyB5SmzwfRPTZUM3qfQCPo1pqhz8sHMrTgc",
  authDomain: "titanium-diode-418307.firebaseapp.com",
  projectId: "titanium-diode-418307",
  storageBucket: "titanium-diode-418307.appspot.com",
  messagingSenderId: "451315736773",
  appId: "1:451315736773:web:98831b2c30eafe37b1d0ac",
};

/* ---------- init (once) ---------- */
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

/* ---------- auth singleton ---------- */
export const auth = getAuth(app);

/* ---------- messaging singleton (lazy) ---------- */
let messagingPromise: Promise<Messaging | null> | null = null;

/** Call once and cache the result */
export function getMessagingInstance(): Promise<Messaging | null> {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then(supported => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
}

/* ---------- helper ---------- */
/** Keep ID-tokens in memory; session lives in HttpOnly cookie. */
export async function forceInMemorySession() {
  await setPersistence(auth, browserSessionPersistence); // or .NONE for single-tab mode
}
